import flowerIcon from '../../../assets/images/icons/flower.svg'

export type ScrollHeaderProps = {
  bannerText: string | string[]
}

const ScrollHeader = ({ bannerText }: ScrollHeaderProps) => {
  const bannerItems = Array.isArray(bannerText) ? bannerText : [bannerText]

  const item = (
    <div className="mx-6 flex items-center gap-10 whitespace-nowrap">
      {bannerItems.map((label, index) => (
        <div key={`${label}-${index}`} className="flex items-center gap-10">
          <span className="font-gilroy-bold text-xl uppercase text-white md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl">
            {label}
          </span>
          <img src={flowerIcon} alt="" aria-hidden className="h-5 w-5 object-contain md:h-6 md:w-6 lg:h-10 lg:w-10 xl:h-12 xl:w-12 2xl:h-13 2xl:w-13" />
        </div>
      ))}
    </div>
  )

  return (
    <section className="my-6 w-full overflow-hidden py-4">
      <div className="flex w-max animate-[scrollHeader_18s_linear_infinite]">
        <div className="flex shrink-0">
          {item}
          {item}
          {item}
          {item}
          {item}
          {item}
          {item}
          {item}
        </div>
        <div className="flex shrink-0">
          {item}
          {item}
          {item}
          {item}
          {item}
          {item}
          {item}
          {item}
        </div>
      </div>

      <style>
        {`
          @keyframes scrollHeader {
            0% { transform: translateX(0); }
            100% { transform: translateX(-3%); }
          }
        `}
      </style>
    </section>
  )
}

export default ScrollHeader
